export default {
  setItens(state, payload) {
    state.itens = payload;
  },
  setTipo(state, payload) {
    state.tipo = payload;
  }
};
